import { Wifi, Zap, Headset, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: Wifi,
    title: "Wi-Fi estável",
    copy: "Conexão firme em todos os cômodos pra trabalhar, assistir e jogar sem travar.",
  },
  {
    icon: Zap,
    title: "Instalação rápida",
    copy: "Agende pelo WhatsApp e tenha sua internet no ar sem complicação.",
  },
  {
    icon: Headset,
    title: "Suporte local",
    copy: "Time de Bertioga que resolve do seu lado, sem robô e sem espera.",
  },
  {
    icon: ShieldCheck,
    title: "Preço justo",
    copy: "Planos a partir de R$ 79,90/mês, com valor fixo todo mês.",
  },
];

export default function Differentials() {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="scroll-mt-24 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] text-violet-400">
            / DIFERENCIAIS
          </p>
          <h2 className="mt-5 font-display text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
            Por que escolher a HPNET.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.1}>
              <div className="h-full rounded-2xl border border-white/10 bg-surface p-7 transition-all duration-300 hover:-translate-y-1 hover:border-violet-600/40">
                <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-violet-600/30 bg-violet-600/15">
                  <item.icon className="h-5 w-5 text-violet-300" />
                </div>
                <h3 className="mt-6 font-display text-xl font-bold">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-white/60">{item.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
